// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1006":"b30758f4","61094":"b30758f4"}[chunkId] + ".chunk.css";
};